import {ChangeDetectorRef, Component} from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';
import {NavigationService} from '../../services/nav/navigation.service';
import {NavMenuItem} from '../../nav/nav-menu-item';
import {UserService} from '../../services/user/user.service';
import {TranslateService} from '@ngx-translate/core';
import {NavComponent} from '../../nav/nav.component';
import {VersionComponent} from '../../version/version.component';
import {OrganizationMinimalDto} from '@api/utisha-backend';

@Component({
    selector: 'app-teacher-home',
    templateUrl: './teacher-home.component.html',
    styleUrls: ['./teacher-home.component.scss'],
    imports: [NavComponent, VersionComponent]
})
export class TeacherHomeComponent {
  mobileQuery: MediaQueryList;
  nav: NavigationService;
  private mobileQueryListener: () => void;
  menuItems: NavMenuItem[] = [];

  constructor(changeDetectorRef: ChangeDetectorRef,
              media: MediaMatcher,
              navService: NavigationService,
              translate: TranslateService,
              private userService: UserService) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    this.nav = navService;
    Promise.all([this.userService.isPlatformAdmin(), this.userService.currentOrgRoles()])
      .then(([isPlatformAdmin, orgRoles]) => {
        const isAdmin = isPlatformAdmin || orgRoles.includes(OrganizationMinimalDto.RolesEnum.Admin);
        const isTeacherOrAdmin = isPlatformAdmin || orgRoles.some(r =>
          r === OrganizationMinimalDto.RolesEnum.Teacher || r === OrganizationMinimalDto.RolesEnum.Admin
        );
        this.generateMenuItems(isAdmin, isTeacherOrAdmin);
      });
  }

  generateMenuItems(isAdmin: boolean, isTeacherOrAdmin: boolean): void {
    this.menuItems = [];
    if (isAdmin) {
      this.menuItems.push({title: 'admin.dashboard.label', url: '/admin/dashboard', icon: 'bar-chart'});
    }
    this.menuItems.push({title: 'events', url: '/teacher/events', icon: 'calendar'});
    if (isTeacherOrAdmin) {
      this.menuItems.push({title: 'videos.label', url: '/teacher/videos', icon: 'video'});
    }
    this.menuItems.push({title: 'articles.label', url: '/teacher/articles', icon: 'file-text'});
    if (isAdmin) {
      // Admin-only: the meetings calendar overview shows every teacher's
      // schedule and is guarded by AdminGuard on the route. Regular
      // teachers manage their own events via the `events` entry above.
      this.menuItems.push({title: 'meetings', url: '/teacher/meetings', icon: 'users'});
      this.menuItems.push({title: 'products', url: '/teacher/products', icon: 'shopping-cart'});
      // Users tile sits at the end of the admin nav per team preference —
      // it's an admin-only maintenance screen, not a daily workflow page.
      this.menuItems.push({title: 'users', url: '/admin/users', icon: 'user'});
    }
    if (!isAdmin) {
      this.menuItems.push({title: 'help.label', url: '/teacher/help', icon: 'info'});
    }
    // Referrals and timesheets have moved to the admin dashboard's Quick
    // Actions tile grid so the main nav stays focused on day-to-day work.
  }
}
